<template>
  <div class="new-order__main">
    <div class="container">
      <div class="new-order__part">
        <div class="new-order__part-icon">
          <div class="icon-button icon-button--round icon-button--blue">
            <i class="ri-arrow-up-circle-line"></i>
          </div>
        </div>
        <Multiselect
          :value="pickup"
          :options="pickups"
          :placeholder="pickup ? pickup.businessName : 'Pick Up'"
          class="new-order-search"
          track-by="id"
          label="businessName"
          :show-labels="false"
          :allow-empty="false"
          :loading="isLoadingPickup"
          @select="changePickup"
          @search-change="searchPickup"
        >
          <template slot="singleLabel" slot-scope="props">
            <div class="label__item">
              <span class="label__title">{{ props.option.businessName }}</span>
            </div>
          </template>
          <template slot="option" slot-scope="props" style="pointer-events: none">
            <div class="option__item">
              <div class="option__item-icon">
                <i class="ri-checkbox-circle-fill"></i>
              </div>
              <div class="option__item-customer">
                <div class="option__item-name">
                  <span v-if="props.option.fathersName">{{ props.option.fathersName }}’ </span>
                  <span>{{ props.option.firstName }} </span>
                  <span>{{ props.option.middleInitial }} </span>
                  <span>{{ props.option.lastName }} </span>
                  <span v-if="props.option.nickName">({{ props.option.nickName }})</span>
                </div>
                <div v-if="props.option.isOutsideOperativeArea" class="option__item-orange">
                  <span>Sorry, this person is outside STS delivery area</span>
                </div>
                <div class="option__item-name">
                  <span>{{ props.option.businessName }}</span>
                </div>
                <div class="option__item-address">
                  <span>Address: </span>
                  <span>{{ props.option.address }} {{ props.option.city }}</span>
                </div>
              </div>
            </div>
          </template>
          <template slot="noOptions">
            <div class="label__item--options">
              <span class="label__title">Please type business name</span>
            </div>
          </template>
          <template slot="noResult">
            <div class="label__item--options">
              <span class="label__title">No business name like that, please try again</span>
            </div>
          </template>
        </Multiselect>
        <div class="new-order__part-button">
          <button
            v-if="showBtn"
            class="button button--fill button--fill--blue"
            :class="{'button--fill--grey': pickupBtn}"
            @click="chooseMe('pickup')"
          >
            Choose me
          </button>
        </div>
      </div>
      <div class="new-order__part">
        <div class="new-order__part-icon">
          <div class="icon-button icon-button--round icon-button--orange">
            <i class="ri-arrow-down-circle-line"></i>
          </div>
        </div>
        <Multiselect
          :value="dropOff"
          :options="dropOffs"
          :placeholder="dropOff ? dropOff.businessName : 'Drop-off'"
          class="new-order-search"
          track-by="id"
          label="businessName"
          :show-labels="false"
          :allow-empty="false"
          :loading="isLoadingDropOff"
          @select="changeDropOff"
          @search-change="searchDropOff"
        >
          <template slot="singleLabel" slot-scope="props">
            <div class="label__item">
              <span class="label__title">{{ props.option.businessName }}</span>
            </div>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__item">
              <div class="option__item-icon">
                <i class="ri-checkbox-circle-fill"></i>
              </div>
              <div class="option__item-customer">
                <div class="option__item-name">
                  <span v-if="props.option.fathersName">{{ props.option.fathersName }}’ </span>
                  <span>{{ props.option.firstName }} </span>
                  <span>{{ props.option.middleInitial }} </span>
                  <span>{{ props.option.lastName }} </span>
                  <span v-if="props.option.nickName">({{ props.option.nickName }})</span>
                </div>
                <div v-if="props.option.isOutsideOperativeArea" class="option__item-orange">
                  <span>Sorry, this person is outside STS delivery area</span>
                </div>
                <div class="option__item-name">
                  <span>{{ props.option.businessName }}</span>
                </div>
                <div class="option__item-address">
                  <span>Address: </span>
                  <span>{{ props.option.address }} {{ props.option.city }}</span>
                </div>
              </div>
            </div>
          </template>
          <template slot="noOptions">
            <div class="label__item--options">
              <span class="label__title">Please type business name</span>
            </div>
          </template>
          <template slot="noResult">
            <div class="label__item--options">
              <span class="label__title">No business name like that, please try again</span>
            </div>
          </template>
        </Multiselect>
        <div class="new-order__part-button">
          <button
            v-if="showBtn"
            class="button button--fill button--fill--blue"
            :class="{'button--fill--grey': dropOffBtn}"
            @click="chooseMe('dropOff')"
          >
            Choose me
          </button>
        </div>
      </div>
      <div class="new-order__part new-order__part--label">
        <div class="new-order__part-label">Who pays:</div>
        <div class="new-order__part-icon">
          <div class="icon-button icon-button--round icon-button--blue">
            <i class="ri-account-pin-circle-fill"></i>
          </div>
        </div>
        <Multiselect
          :value="billing"
          :options="billings"
          :placeholder="billing ? billing.businessName : 'Billing'"
          class="new-order-search"
          track-by="id"
          label="businessName"
          :show-labels="false"
          :allow-empty="false"
          :loading="isLoadingBilling"
          @select="changeBilling"
          @search-change="searchBilling"
        >
          <template slot="singleLabel" slot-scope="props">
            <div class="label__item">
              <span class="label__title">{{ props.option.businessName }}</span>
            </div>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__item">
              <div class="option__item-icon">
                <i class="ri-checkbox-circle-fill"></i>
              </div>
              <div class="option__item-customer">
                <div class="option__item-name">{{ $dots(props.option.businessName, 40) }}</div>
                <div class="option__item-fname">
                  <span>(FatherName)</span>
                  <span>{{ $dots(props.option.fathersName, 18) }}</span>
                </div>
                <div class="option__item-address">
                  <span>Address: </span>
                  <span>{{ $dots(props.option.address, 40) }}</span>
                </div>
              </div>
              <div class="option__item-nick">{{ props.option.nickName }}</div>
            </div>
          </template>
        </Multiselect>
        <div class="new-order__part-button">
          <button class="button button--fill button--fill--blue" @click="chooseMe('billing')">
            Choose me
          </button>
        </div>
      </div>
      <hr />
      <div class="new-order__part">
        <date-picker
          :value="date"
          format="YYYY-MM-DD"
          placeholder="Select date"
          type="date"
          :lang="lang"
          :disabled-date="disableWeekends"
          popup-class="new-order-date-popup"
          class="new-order-date"
          @input="changeDate"
        >
          <template slot="icon-calendar">
            <i class="ri-calendar-fill"></i>
          </template>
        </date-picker>
        <div class="new-order__date-day">{{ dayLabel }}</div>
        <div v-if="dayHint" class="new-order__date-hint">{{ dayHint }}</div>
      </div>

      <div class="new-order__part">
        <label class="new-order__label">
          <textarea
            :value="note"
            class="new-order__textarea"
            placeholder="Add a note here if required..."
            @input="changeNote"
          ></textarea>
        </label>
      </div>
      <FilesUpload />
    </div>
  </div>
</template>

<script>
import FilesUpload from './FilesUpload'
import {mapGetters, mapState, mapMutations} from 'vuex'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import DatePicker from 'vue2-datepicker'
import {earliestRouteDate, normalizeRouteDate, routeDayLabel, routeDayHint} from '@/utils/routeDate'

export default {
  name: 'PublicNewOrderCustomer',
  components: {Multiselect, FilesUpload, DatePicker},
  data() {
    return {
      localDate: earliestRouteDate().toDate(),
      dropOffBtn: false,
      pickupBtn: false,
      isLoadingPickup: false,
      isLoadingDropOff: false,
      isLoadingBilling: false,
      showBtn: false,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1
        }
      }
    }
  },
  computed: {
    ...mapState({
      customer: s => s.payment.customers.customer,
      pickup: s => s.newOrder.pickup,
      pickups: s => {
        return s.newOrder.searchPickup.customers.map(c => {
          if (c.isOutsideOperativeArea) c.$isDisabled = true
          return c
        })
      },
      dropOff: s => s.newOrder.dropOff,
      dropOffs: s => {
        return s.newOrder.searchDropOff.customers.map(c => {
          if (c.isOutsideOperativeArea) c.$isDisabled = true
          return c
        })
      },
      billing: s => s.newOrder.billing,
      billings: s => s.newOrder.searchBilling.customers,
      note: s => s.newOrder.note,
      date: s => s.newOrder.date
    }),
    ...mapGetters({
      customerID: 'payment/customers/idCustomer'
    }),
    dayLabel() {
      return routeDayLabel(this.date)
    },
    dayHint() {
      return routeDayHint(this.date)
    }
  },
  watch: {
    pickup(cus) {
      this.customerID !== cus.id ? (this.dropOffBtn = false) : null
    },
    dropOff(cus) {
      this.customerID !== cus.id ? (this.pickupBtn = false) : null
    },
    customer(cus) {
      if (!cus?.isOutsideOperativeArea) this.showBtn = true
    }
  },
  mounted() {
    this.$store.commit('newOrder/setBilling', this.customer)
    this.$store.commit('newOrder/setDate', this.localDate)
  },
  methods: {
    ...mapMutations({
      setPickup: 'newOrder/setPickup',
      setDropOff: 'newOrder/setDropOff',
      setBilling: 'newOrder/setBilling',
      setNote: 'newOrder/setNote',
      setDate: 'newOrder/setDate'
    }),
    changePickup(cus) {
      this.setPickup(cus)
    },
    changeDropOff(cus) {
      this.setDropOff(cus)
    },
    changeBilling(cus) {
      this.setBilling(cus)
    },
    changeNote(e) {
      this.setNote(e.target.value)
    },
    searchPickup: _.debounce(async function(e) {
      if (!e) return
      this.isLoadingPickup = true
      this.$store.commit('newOrder/searchPickup/reset')
      await this.$store.dispatch('newOrder/searchPickup/fetch', {
        'filters[generalSearch]': e,
        'filters[publicOrCompanyID]': process.env.VUE_APP_COMPANY_ID
      })
      this.isLoadingPickup = false
    }, 500),
    searchDropOff: _.debounce(async function(e) {
      if (!e) return
      this.isLoadingDropOff = true
      this.$store.commit('newOrder/searchDropOff/reset')
      await this.$store.dispatch('newOrder/searchDropOff/fetch', {
        'filters[generalSearch]': e,
        'filters[publicOrCompanyID]': process.env.VUE_APP_COMPANY_ID
      })
      this.isLoadingDropOff = false
    }, 500),
    searchBilling: _.debounce(async function(e) {
      if (!e) return
      this.isLoadingBilling = true
      this.$store.commit('newOrder/searchBilling/reset')
      await this.$store.dispatch('newOrder/searchBilling/fetch', {
        'filters[generalSearch]': e,
        'filters[publicOrCompanyID]': process.env.VUE_APP_COMPANY_ID,
        'filters[withoutEnterprise]': true,
        'filters[withCellPhone]': true
      })
      this.isLoadingBilling = false
    }, 500),
    async chooseMe(type) {
      const customer = this.$store.getters['payment/customers/customer']
      if (type === 'pickup' && !this.pickupBtn) {
        this.$store.commit('newOrder/setPickup', customer)
        this.dropOffBtn = true
        this.pickupBtn = false
      } else if (type === 'dropOff' && !this.dropOffBtn) {
        this.$store.commit('newOrder/setDropOff', customer)
        this.pickupBtn = true
        this.dropOffBtn = false
      } else if (type === 'billing') {
        this.$store.commit('newOrder/setBilling', customer)
      }
    },
    // Clearing the picker (×) or picking a non-bookable day falls back to the
    // earliest bookable day instead of leaving the order dateless.
    changeDate(date) {
      this.setDate(normalizeRouteDate(date).toDate())
    },
    disableWeekends(date) {
      const day = new Date(date).getDay()
      return day === 0 || day === 6 || date < earliestRouteDate().toDate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'style';
</style>
